module.exports = __webpack_public_path__ + "static/media/share_button.7634bc8b.png";